var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-card", [
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  "highlight-current-row": "",
                  size: "small",
                  "max-height": "800"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "Id",
                    label: _vm.translateWords.Id,
                    width: "100",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "ChangeTypeName",
                    label: _vm.translateWords.ChangeTypeName,
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "QtyChangeBefore",
                    label: _vm.translateWords.QtyChangeBefore,
                    width: "150"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "QtyChangeAfter",
                    label: _vm.translateWords.QtyChangeAfter,
                    width: "150"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "OpUserName",
                    label: _vm.translateWords.OpUserName,
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    formatter: _vm.dateFormat,
                    prop: "OpTime",
                    label: _vm.translateWords.OpTime,
                    "show-overflow-tooltip": ""
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              staticStyle: { margin: "1em 0" },
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [10, 20, 50, 100, 200],
                "current-page": _vm.currPage,
                "page-size": _vm.pageSize,
                total: _vm.total
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2737302c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2737302c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SampleChangeLog.vue
// module id = null
// module chunks = 